import React, { useState } from 'react';
import styles from './index.module.css';
import PendingTable from './components/PendingTable';

const PendingForDispatch = () => {
  const [activeSection, setActiveSection] = useState('pending');

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'pending' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('pending')}
          >
            Pending for Dispatch
          </button>
        </div>

        {activeSection === 'pending' && (
          <div className={styles.sectionContent}>
            <PendingTable />
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingForDispatch;